import * as types from './orderStatusActionTypes';

const initialState = {
  orderStatusData: null,
  orderStatusList: null,
  orderStatusHistorySortData: null,
  error: {
    type: null,
    data: null,
  },
  createOrderStatusData: null,
  createOrderStatusError: null,
  updateOrderStatusData: null,
  updateOrderStatusError: null,
  deleteOrderStatusData: null,
  deleteOrderStatusError: null,
};

export const orderStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ORDER_STATUS_DATA:
      console.log('action?.payload')
      console.log(action?.payload)
      return {
        ...state,
        orderStatusData: action?.payload ? { ...action?.payload } : null,
        orderStatusList: action?.payload?.OrderStatusList ? 
        [...action?.payload.OrderStatusList] : [],
      };
    case types.GET_ORDER_STATUS_ERROR:
      return {
        ...state,
        error: {
          type: types.GET_ORDER_STATUS_ERROR,
          data: action.payload,
        },
      };
    case types.SET_ORDER_HISTORY_SORT_DATA:
      return {
        ...state,
        orderStatusHistorySortData: {
          orderBy: action.payload.orderBy,
          order: action.payload.order
        }
      };
    case types.CREATE_ORDER_STATUS_REQUEST:
      return {
        ...state,
        createOrderStatusError: null,
      };

    case types.CREATE_ORDER_STATUS_DATA:
      return {
        ...state,
        createOrderStatusData: action.payload,
        createOrderStatusError: null,
      };

    case types.CREATE_ORDER_STATUS_ERROR:
      return {
        ...state,
        createOrderStatusData: null,
        createOrderStatusError: action.payload,
      };

    case types.UPDATE_ORDER_STATUS_REQUEST:
      return {
        ...state,
        updateOrderStatusError: null,
      };

    case types.UPDATE_ORDER_STATUS_DATA:
      return {
        ...state,
        updateOrderStatusData: action.payload,
        updateOrderStatusError: null,
      };

    case types.UPDATE_ORDER_STATUS_ERROR:
      return {
        ...state,
        updateOrderStatusData: null,
        updateOrderStatusError: action.payload,
      };

    case types.DELETE_ORDER_STATUS_REQUEST:
      return {
        ...state,
        deleteOrderStatusError: null,
      };

    case types.DELETE_ORDER_STATUS_DATA:
      return {
        ...state,
        deleteOrderStatusData: action.payload,
        deleteOrderStatusError: null,
      };

    case types.DELETE_ORDER_STATUS_ERROR:
      return {
        ...state,
        deleteOrderStatusData: null,
        deleteOrderStatusError: action.payload,
      };

    default:
      return state;
  }
};